/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".map-wrapper[_ngcontent-%COMP%]{position:relative;height:100%;min-height:200px;overflow-y:hidden}.searchMarker[_ngcontent-%COMP%]    >div>img{height:35px}.map-wrapper[_ngcontent-%COMP%], ngui-map[_ngcontent-%COMP%], ngui-map[_ngcontent-%COMP%]     .google-map{min-height:250px}.map-wrapper[_ngcontent-%COMP%]     app-modal .panel{top:30%}[_nghost-%COMP%]   app-panel-message[_ngcontent-%COMP%]{z-index:1}[_nghost-%COMP%]     .listing-preview{background-color:#5f6062;padding-top:20px}#heat-map[_ngcontent-%COMP%]{top:0}"];
export { styles as styles };
